<div class="flex flex-column border-bottom-1 surface-border p-6">
    <h3 class="text-xl font-bold">Mes coordonnées</h3>
</div>
<hr>
<div class="w-full surface-border py-4 px-6">
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
            <label for="nomPrenom" class="font-bold">Nom Prénom</label>
            <input pInputText id="nomPrenom" aria-label="nomPrenom" [value]="nomPrenom()" readonly />
        </div>
        <div class="flex flex-col gap-2">
            <label for="entreprise" class="font-bold">Entreprise</label>
            <input pInputText id="entreprise" aria-label="entreprise" [value]="entreprise()" readonly />
        </div>
        <div class="flex flex-col gap-2">
            <div class="flex align-items-center gap-2">
                <label for="email" class="font-bold">Email</label>
                @if (!isEditingEmail()) {
                    <button 
                        type="button"
                        class="p-0 border-none bg-transparent cursor-pointer" 
                        pTooltip="Modifier l'email"
                        (click)="startEditEmail()"
                        aria-label="Modifier"
                    >
                        <i class="pi pi-pencil text-orange-500"></i>
                    </button>
                } @else {
                    <button pButton 
                            class="p-button-success p-button-outlined p-button-sm text-xs px-2 py-1" 
                            label="Sauvegarder"
                            (click)="askUpdateEmail()"></button>
                    <button pButton 
                            class="p-button-danger p-button-outlined p-button-sm text-xs px-2 py-1" 
                            label="Annuler"
                            (click)="cancelEditEmail()"></button>
                }
            </div>
            @if (isEditingEmail()) {
                <input pInputText
                    id="update-email"
                    [(ngModel)]="tempEmail" />
            } @else {
                <input pInputText
                    id="email"
                    [value]="email()"
                    aria-label="email"
                    readonly />
            }
              
            <div *ngIf="errorEmail" class="p-error text-sm mt-1">{{ errorEmail }}</div>
        </div>
        <div class="flex flex-col gap-2">
            <div class="flex align-items-center gap-2">
                <label for="telephone" class="font-bold">Téléphone</label>
                @if (!isEditingTelephone()) {
                    <button 
                        type="button"
                        class="p-0 border-none bg-transparent cursor-pointer" 
                        pTooltip="Modifier le téléphone"
                        (click)="startEditTelephone()"
                        aria-label="Modifier"
                    >
                        <i class="pi pi-pencil text-orange-500"></i>
                    </button>
                } @else {
                    <button pButton 
                            class="p-button-success p-button-outlined p-button-sm text-xs px-2 py-1" 
                            label="Sauvegarder"
                            (click)="saveTelephone()"></button>
                    <button pButton 
                            class="p-button-danger p-button-outlined p-button-sm text-xs px-2 py-1" 
                            label="Annuler"
                            (click)="cancelEditTelephone()"></button>
                }
            </div>
            @if (isEditingTelephone()) {
                <input 
                    pInputText 
                    id="update-telephone"
                    [(ngModel)]="tempTelephone" />
            } @else {
                <input 
                    pInputText 
                    id="telephone"
                    aria-label="telephone"
                    [value]="telephone()"
                    readonly />
            }
        </div>
    </div>

    <hr class="my-4">

    <div class="flex flex-col gap-2">
        <button
            pButton
            pRipple
            type="button"
            label="Supprimer mon compte"
            icon="pi pi-trash"
            class="p-button-danger w-full"
            (click)="deleteAccount()"
        ></button>
    </div>
</div>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>

<p-dialog
  [(visible)]="displayConfirmUpdateEmailModal"
  [modal]="true"
  [closable]="true"
  (onHide)="displayConfirmUpdateEmailModal = false"
  [breakpoints]="{ '1199px': '80vw', '700px': '90vw' }"
  [style]="{ width: '50vw' }"
>
  <ng-template pTemplate="header">
    <h3>Modification de l'email</h3>
  </ng-template>

  <p-message severity="warn"
    >Modifier son email vous déconnectera de la plateforme. Merci de vous reconnecter avec l'adresse email renseignée.</p-message
  >

    <div class="flex justify-center w-full mt-2">
      <button
        pButton
        pRipple
        type="button"
        label="Valider"
        class="p-button p-button-success"
        (click)="saveEmail()"
      ></button>

      <button
        pButton
        pRipple
        type="button"
        label="Annuler"
        class="p-button p-button-danger ml-1"
        (click)="cancelEditEmail()"
      ></button>
    </div>
</p-dialog>